import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { Ticket } from '../interfaces/tickets/Ticket';
import { RequestsServices } from './requests.service';

@Injectable({
  providedIn: 'root'
})
export class NgTicketsService {

  constructor(private request: RequestsServices) { }

  getAvailableProducts(establishmentId): Observable<Ticket[]> {
    return from(this.request.get({path: 'ticket_product', endPoint: '/available', params: { establishmentId }}));
  }
}
